import store from "@/store";

export function setCommonInterceptors(instance) {

    instance.interceptors.request.use(
        (config) => {
            console.log("LOADING:", config.url, config.skipLoading);
            if (!config.skipLoading) {
                store.commit("uiStore/START_LOADING");
            }

            return config;
        },
        (error) => {
            // request 에러도 loading 감소
            store.commit("uiStore/END_LOADING");

            return Promise.reject(error);
        }
    );

    instance.interceptors.response.use(
        (response) => {
            if (!response.config.skipLoading) {
                store.commit("uiStore/END_LOADING");
            }

            return response;
        },
        (error) => {
            // response 에러도 loading 감소
            if (!error.config?.skipLoading) {
                store.commit("uiStore/END_LOADING");
            }

            return Promise.reject(error);
        }
    );

    return instance;
}